import { buildModule } from '../utils';

import detail from './detail';
import lazy from './lazy';
import list from './list';

export default buildModule()
	.withSubmodules({
		detail,
		list,
		lazy,
	});
